/* eslint-disable no-tabs, no-var, one-var, quotes, operator-linebreak */
/* eslint-disable space-before-function-paren, space-before-blocks */
/* eslint indent: ["error", "tab"] */
/* prettier-ignore */

/*! Copyright (c) Jonas Mosbech - https://github.com/jmosbech/StickyTableHeaders
	MIT license info: https://github.com/jmosbech/StickyTableHeaders/blob/master/license.txt */

(function($, window, undefined) {
  'use strict';

  const name = 'stickyTableHeaders';
  const defaults = {
    fixedOffset: 0,
    leftOffset: 0,
    marginTop: 0,
    objDocument: document,
    objHead: 'head',
    objWindow: window,
    scrollableArea: window,
    cacheHeaderHeight: false,
    zIndex: 3,
  };

  let id = 0;

  function Plugin(el, options) {
    // To avoid scope issues, use 'base' instead of 'this'
    // to reference this class from internal events and functions.
    const base = this;

    // Access to jQuery and DOM versions of element
    base.$el = $(el);
    base.el = el;
    base.id = id++;

    // Listen for destroyed, call teardown
    base.$el.bind('destroyed',
      $.proxy(base.teardown, base));

    // Cache DOM refs for performance reasons
    base.$clonedHeader = null;
    base.$originalHeader = null;

    // Cache header height for performance reasons
    base.cachedHeaderHeight = null;

    // Keep track of state
    base.isSticky = false;
    base.hasBeenSticky = false;
    base.leftOffset = null;
    base.topOffset = null;

    base.init = function() {
      base.setOptions(options);

      base.$el.each(function() {
        // remove padding on <table> to fix issue #7
        $(this).css('padding', 0);

        base.$originalHeader = $('thead:first', this);
        base.$clonedHeader = base.$originalHeader.clone();

        $(this).trigger('clonedHeader.' + name, [base.$clonedHeader]);

        base.$clonedHeader.addClass('tableFloatingHeader');
        base.$clonedHeader.css({ display: 'none', opacity: 0.0 });

        base.$originalHeader.addClass('tableFloatingHeaderOriginal');
        base.$originalHeader.after(base.$clonedHeader);

        base.$printStyle = $('<style type="text/css" media="print">' +
          '.tableFloatingHeader{display:none !important;}' +
          '.tableFloatingHeaderOriginal{position:static !important;}' +
          '</style>');

        base.$head.append(base.$printStyle);
      });

      base.$clonedHeader.find('input, select').attr('disabled', true);

      base.updateWidth();
      base.toggleHeaders();

      base.bind();
    };

    base.destroy = function() {
      base.$el.unbind('destroyed', base.teardown);
      base.teardown();
    };

    base.teardown = function() {
      if (base.isSticky) {
        base.$originalHeader.css('position', 'static');
      }

      $.removeData(base.el, 'plugin_' + name);
      base.unbind();

      base.$clonedHeader.remove();
      base.$originalHeader.removeClass('tableFloatingHeaderOriginal');
      base.$originalHeader.css('visibility', 'visible');
      base.$printStyle.remove();

      base.el = null;
      base.$el = null;
    };

    base.bind = function() {
      base.$container.scroll(base.toggleHeaders);
      base.$container.resize(base.toggleHeaders);
      base.$container.resize(base.updateWidth);

      base.$scrollableArea.on('scroll.' + name, base.toggleHeaders);

      if (!base.isWindowScrolling) {
        base.$window.on('scroll.' + name + base.id, base.setPositionValues);
        base.$window.on('resize.' + name + base.id, base.toggleHeaders);
      }

      base.$scrollableArea.on('resize.' + name, base.toggleHeaders);
      base.$scrollableArea.on('resize.' + name, base.updateWidth);
    };

    base.unbind = function() {
      // unbind window events by specifying handle so we don't remove too much
      base.$scrollableArea.off('.' + name, base.toggleHeaders);

      if (!base.isWindowScrolling) {
        base.$window.off('.' + name + base.id, base.setPositionValues);
        base.$window.off('.' + name + base.id, base.toggleHeaders);
      }

      base.$scrollableArea.off('.' + name, base.updateWidth);
    };

    // We debounce the functions bound to the scroll and resize events
    base.debounce = function(fn, delay) {
      let timer = null;

      return function() {
        clearTimeout(timer);

        timer = setTimeout(function() {
          fn.apply(this, arguments);
        }, delay);
      };
    };

    base.toggleHeaders = base.debounce(function() {
      if (base.$el) {
        base.$el.each(function() {
          const newTopOffset = base.isWindowScrolling ? (
              isNaN(base.options.fixedOffset) ?
                base.options.fixedOffset.outerHeight() :
                base.options.fixedOffset
            ) :
            base.$scrollableArea.offset().top + (
              !isNaN(base.options.fixedOffset) ? base.options.fixedOffset : 0
            );

          const scrollTop = base.$scrollableArea.scrollTop() + newTopOffset;
          const scrollLeft = base.$scrollableArea.scrollLeft();

          let headerHeight;
          let notScrolledPastBottom;

          const scrolledPastTop = base.isWindowScrolling ?
            scrollTop > $(this).offset().top :
            newTopOffset > $(this).offset().top;

          if (scrolledPastTop) {
            headerHeight = base.options.cacheHeaderHeight ? base.cachedHeaderHeight : base.$clonedHeader.height();
            notScrolledPastBottom = (base.isWindowScrolling ? scrollTop : 0) <
              ($(this).offset().top + $(this).height() - headerHeight - (base.isWindowScrolling ? 0 : newTopOffset));
          }


          let newLeft;

          if (scrolledPastTop && notScrolledPastBottom) {
            newLeft = $(this).offset().left - scrollLeft + base.options.leftOffset;

            base.$originalHeader.css({
              'position': 'fixed',
              'margin-top': base.options.marginTop,
              'left': newLeft,
              'z-index': base.options.zIndex,
            });
            base.leftOffset = newLeft;
            base.topOffset = newTopOffset;
            base.$clonedHeader.css('display', '');

            if (!base.isSticky) {
              base.isSticky = true;
              // make sure the width is correct: the user might have resized the browser while in static mode
              base.updateWidth();

              $(this).trigger('enabledStickiness.' + name);
            }

            base.setPositionValues();
          } else if (base.isSticky) {
            base.$originalHeader.css('position', 'static');
            base.$clonedHeader.css('display', 'none');
            base.isSticky = false;
            base.resetWidth($('td,th', base.$clonedHeader), $('td,th', base.$originalHeader));
            $(this).trigger('disabledStickiness.' + name);
          }
        });
      }
    }, 0);

    base.setPositionValues = base.debounce(function() {
      const winScrollTop = Math.round(base.$window.scrollTop());
      const winScrollLeft = Math.round(base.$window.scrollLeft());

      const winHeight = Math.round(base.$window.height())
      const winWidth = Math.round(base.$window.width())

      const docHeight = Math.ceil(base.$document.height())
      const docWidth = Math.ceil(base.$document.width())

      if (!base.isSticky ||
        winScrollTop < 0 || winScrollTop + winHeight > docHeight ||
        winScrollLeft < 0 || winScrollLeft + winWidth > docWidth) {
        return;
      }

      base.$originalHeader.css({
        'top': base.topOffset - (base.isWindowScrolling ? 0 : winScrollTop),
        'left': base.leftOffset - (base.isWindowScrolling ? 0 : winScrollLeft),
      });

      const parentClientWidth = base.$container.width();

      if (base.$originalHeader.width() > parentClientWidth) {
        const scrollLeft = base.$container.scrollLeft();
        const clipLeft = scrollLeft;
        const clipRight = parentClientWidth + scrollLeft;

        base.$originalHeader.css({
          'clip': 'rect(0px, ' + clipRight + 'px, '
            + base.$originalHeader.height() + 'px, '
            + clipLeft + 'px)',
        });
      } else {
        base.$originalHeader.css({ 'clip': '' });
      }
    }, 0);

    base.updateWidth = base.debounce(function() {
      if (!base.isSticky) {
        return;
      }

      // Copy cell widths from clone
      if (!base.$originalHeaderCells) {
        base.$originalHeaderCells = $('th,td', base.$originalHeader);
      }

      if (!base.$clonedHeaderCells) {
        base.$clonedHeaderCells = $('th,td', base.$clonedHeader);
      }

      base.$clonedHeaderCells.each(function(index, el) {
        el.innerHTML = base.$originalHeaderCells.eq(index).html();
      });

      const cellWidths = base.getWidth(base.$clonedHeaderCells);
      base.setWidth(cellWidths, base.$clonedHeaderCells, base.$originalHeaderCells);

      // Copy row width from whole table
      base.$originalHeader.css('width', base.$clonedHeader.width());

      // If we're caching the height, we need to update the cached value when the width changes
      if (base.options.cacheHeaderHeight) {
        base.cachedHeaderHeight = base.$clonedHeader.height();
      }
    }, 0);

    base.getWidth = function($clonedHeaders) {
      const widths = [];

      $clonedHeaders.each(function(index) {
        const $this = $(this);

        let width;

        if ($this.css('box-sizing') === 'border-box') {
          const boundingClientRect = $this[0].getBoundingClientRect();

          if (boundingClientRect.width) {
            width = boundingClientRect.width; // #39: border-box bug
          } else {
            width = boundingClientRect.right - boundingClientRect.left; // ie8 bug: getBoundingClientRect() does not have a width property
          }
        } else {
          const $origTh = $('th', base.$originalHeader);

          if ($origTh.css('border-collapse') === 'collapse') {
            if (window.getComputedStyle) {
              width = parseFloat(window.getComputedStyle(this, null).width);
            } else {
              // ie8 only
              const leftPadding = parseFloat($this.css('padding-left'));
              const rightPadding = parseFloat($this.css('padding-right'));
              // Needs more investigation - this is assuming constant border around this cell and it's neighbours.
              const border = parseFloat($this.css('border-width'));

              width = $this.outerWidth() - leftPadding - rightPadding - border;
            }
          } else {
            width = $this.width();
          }
        }

        widths[index] = width;
      });

      return widths;
    };

    base.setWidth = function(widths, $clonedHeaders, $origHeaders) {
      $clonedHeaders.each(function(index) {
        $origHeaders.eq(index).css({
          'min-width': widths[index],
          'max-width': widths[index],
        });
      });
    };

    base.resetWidth = function($clonedHeaders, $origHeaders) {
      $clonedHeaders.each(function(index) {
        $origHeaders.eq(index).css({
          'min-width': $(this).css('min-width'),
          'max-width': $(this).css('max-width'),
        });
      });
    };

    base.setOptions = function(options) {
      base.options = $.extend({}, defaults, options);
      base.$window = $(base.options.objWindow);
      base.$head = $(base.options.objHead);
      base.$document = $(base.options.objDocument);
      base.$scrollableArea = $(base.options.scrollableArea);
      base.isWindowScrolling = base.$scrollableArea[0] === base.$window[0];
      base.$container = base.options.container != null ? $(base.options.container) : base.$window;
    };

    base.updateOptions = function(options) {
      base.setOptions(options);
      // scrollableArea might have changed
      base.unbind();
      base.bind();
      base.updateWidth();
      base.toggleHeaders();
    };

    // Run initializer
    base.init();
  }

  // A plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[name] = function(options) {
    return this.each(function() {
      const instance = $.data(this, 'plugin_' + name);

      if (instance) {
        if (typeof options === 'string') {
          instance[options].apply(instance);
        } else {
          instance.updateOptions(options);
        }
      } else if (options !== 'destroy') {
        $.data(this, 'plugin_' + name, new Plugin(this, options));
      }
    });
  };

})(jQuery, window);
